export const FAQ_ACCORDION_ITEMS = [
  {
    title: 'PRICING_FAQ_HEADING_1',
    content: 'PRICING_FAQ_CONTENT_1',
  },
  {
    title: 'PRICING_FAQ_HEADING_2',
    content: 'PRICING_FAQ_CONTENT_2',
  },
  {
    title: 'PRICING_FAQ_HEADING_3',
    content: 'PRICING_FAQ_CONTENT_3',
  },
]
